<template>
  <v-card>
    <v-card-title class="pt-8">
      <v-container>
        <v-container>
          <v-row>
            <v-col class="col-md-3">
              <refresh-button
                :loading="isInvoicesRefreshing"
                @click="refreshInvoices()"
              />
            </v-col>
            <v-spacer />
          </v-row>
          <v-row
            justify="center"
            class="mb-0"
          >
            <v-col class="col-md-6 text-center">
              <search-input
                v-model="search"
                :filters="searchFilters"
                :active-filter="activeSearchFilter"
                @filter-change="onSearchFilterChange"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-container>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="invoices"
      :loading="isInvoicesLoading"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:progress>
        <v-progress-linear
          indeterminate
          class="mt-2"
          rounded
        ></v-progress-linear>
        <p class="text-center mt-1">
          Loading...Please wait
        </p>
      </template>
      <template v-slot:body="{ items }">
        <tbody v-if="invoices.length > 0">
          <tr
            v-for="invoice in items"
            :key="invoice.invoice_number"
          >
            <td>
              <span class="primary--text font-weight-medium">{{ invoice.invoice_number }}</span>
            </td>
            <td>{{ invoice.created_at | formatDate }}</td>
            <td>{{ invoice.due_date | formatDate }}</td>
            <td>{{ invoice.hosting_fee | formatCurrency }}</td>
            <td>{{ invoice.operation_fee | formatCurrency }}</td>
            <td>{{ invoice.additional_charges | formatCurrency }}</td>
            <td>{{ invoice.total_amount | formatCurrency }}</td>
            <td>
              <v-chip
                :color="invoice.status === 1 ? 'success' : 'warning'"
                small
              >
                {{ invoice.status === 1 ? 'Paid' : 'Unpaid' }}
              </v-chip>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr v-show="!isInvoicesLoading">
            <td
              :colspan="headers.length"
              style="text-align: center"
            >
              No invoices found
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <data-table-pagination
      :page="pagination.page"
      :page-count="pagination.pageCount"
      @page-change="onPageChange"
      @items-per-page-change="onItemsPerPageChange"
    />
  </v-card>
</template>
<script>
import axios from 'axios'
import _ from 'lodash'
import SearchInput from '@/components/partials/SearchInput.vue'
import RefreshButton from '@/components/partials/RefreshButton.vue'
import DataTablePagination from '@/components/partials/DataTablePagination.vue'

export default {
  components: {
    SearchInput,
    RefreshButton,
    DataTablePagination,
  },
  props: {
    managedClientId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      search: '',
      activeSearchFilter: 'invoice_number',
      searchFilters: [
        {
          text: 'Invoice Number',
          value: 'invoice_number',
        },
      ],
      headers: [
        { text: 'Invoice Number', value: 'invoice_number', sortable: false },
        { text: 'Issue Date', value: 'created_at', sortable: false },
        { text: 'Due Date', value: 'due_date', sortable: false },
        { text: 'Hosting Fee', value: 'hosting_fee', sortable: false },
        { text: 'Operation Fee', value: 'operation_fee', sortable: false },
        { text: 'Additional Charges', value: 'additional_charges', sortable: false },
        { text: 'Total Amount', value: 'total_amount', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
      ],
      isInvoicesLoading: true,
      isInvoicesRefreshing: false,
      invoices: [],
      pagination: {
        page: 1,
        pageCount: 1,
        itemsPerPage: 15,
      },
    }
  },
  computed: {
    refreshTable() {
      return `${this.search}`
    },
  },
  watch: {
    refreshTable() {
      this.pagination.page = 1
      this.getInvoices()
    },
  },
  mounted() {
    this.getInvoices()
  },
  methods: {
    getInvoices: _.debounce(function () {
      this.isInvoicesLoading = true
      axios
        .get(this.buildUrl())
        .then(response => {
          this.invoices = response.data.data
          this.pagination.page = response.data.current_page
          this.pagination.pageCount = response.data.last_page
          this.pagination.itemsPerPage = response.data.per_page
          this.isInvoicesLoading = false
          this.isInvoicesRefreshing = false
        })
        .catch(error => {
          this.isInvoicesLoading = false
          this.isInvoicesRefreshing = false
          this.$notification.error(error.response.data.message)
        })
    }, 500),
    refreshInvoices() {
      this.isInvoicesRefreshing = true
      this.getInvoices()
    },
    onPageChange(page) {
      this.pagination.page = page
      this.getInvoices()
    },
    onItemsPerPageChange(itemsPerPage) {
      this.pagination.itemsPerPage = itemsPerPage
      this.getInvoices()
    },
    onSearchFilterChange(filter) {
      this.activeSearchFilter = filter
    },
    buildUrl() {
      const params = new URLSearchParams()
      params.append('page', this.pagination.page)
      params.append('perPage', this.pagination.itemsPerPage)
      if (this.search) params.append('search', this.search)

      return `managed-clients/${this.managedClientId}/operation-fee-invoices?${params.toString()}`
    },
  },
}
</script>
